<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!hasData" class="dw-empty">No account data available.</div>
    <!-- everything but the tenant name, sized down (dw-stat-tile--compact)
         so the full field set still reads as one concise strip. -->
    <div v-else class="dw-stat-grid dw-stat-grid--compact">
      <div v-if="summary.vehicle_count != null" class="dw-stat-tile dw-stat-tile--compact">
        <div class="dw-stat-tile-label">Vehicles</div>
        <div class="dw-stat-tile-value">{{ summary.vehicle_count }}</div>
      </div>
      <div v-if="summary.driver_count != null" class="dw-stat-tile dw-stat-tile--compact">
        <div class="dw-stat-tile-label">Drivers</div>
        <div class="dw-stat-tile-value">{{ summary.driver_count }}</div>
      </div>
      <div v-if="summary.user_count != null" class="dw-stat-tile dw-stat-tile--compact">
        <div class="dw-stat-tile-label">Users</div>
        <div class="dw-stat-tile-value">{{ summary.user_count }}</div>
      </div>
      <div v-if="summary.vehicle_yards" class="dw-stat-tile dw-stat-tile--compact">
        <div class="dw-stat-tile-label">Yards</div>
        <div class="dw-stat-tile-value">{{ summary.vehicle_yards.length }}</div>
      </div>
      <div v-if="summary.timezone" class="dw-stat-tile dw-stat-tile--compact">
        <div class="dw-stat-tile-label">Timezone</div>
        <div class="dw-stat-tile-value">{{ summary.timezone }}</div>
      </div>
      <div v-if="summary.aws_phone_number" class="dw-stat-tile dw-stat-tile--compact">
        <div class="dw-stat-tile-label">SMS #</div>
        <div class="dw-stat-tile-value">{{ summary.aws_phone_number | prettyPhoneNumber }}</div>
      </div>
      <div v-if="summary.telematics_type" class="dw-stat-tile dw-stat-tile--compact">
        <div class="dw-stat-tile-label">Telematics</div>
        <div class="dw-stat-tile-value">
          <a v-if="summary.samsara_link" target="_blank" rel="noopener" :href="summary.samsara_link">{{ summary.telematics_type }}</a>
          <template v-else>{{ summary.telematics_type }}</template>
        </div>
      </div>
      <div v-if="summary.tenant_type" class="dw-stat-tile dw-stat-tile--compact">
        <div class="dw-stat-tile-label">Ops</div>
        <div class="dw-stat-tile-value">{{ summary.tenant_type }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget_company_overview',
  props: {
    summary: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  computed: {
    hasData() {
      const s = this.summary
      if (!s) return false
      return s.vehicle_count != null || s.driver_count != null || s.user_count != null ||
        !!s.vehicle_yards || !!s.timezone || !!s.aws_phone_number || !!s.telematics_type || !!s.tenant_type
    },
  },
}
</script>
